import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSectionColumn';
import InputBox from '../../components/Modal/InputBox';
import ModalButtons from '../../components/Modal/ModalButtons';
import ResetPasswordSkeleton from '../../components/Skeletons/ResetPasswordSkeleton';

const ResetPasswordModal = ({
	resetPasswordModal,
	loading = false,
	handleResetPassword,
	handleResetPasswordModalClose,
	data
}) => {
	const { t } = useTranslation();
	const { resetPassword, setResetPassword, resetPasswordConfirm, setResetPasswordConfirm, resetPasswordData } = data;
	return (
		<Modal show={resetPasswordModal}>
			<ModalHeading heading={t('screens.users.resetPasswordTitle', { name: resetPasswordData.name })} />
			{loading ? (
				<ResetPasswordSkeleton />
			) : (
				<ModalForm style={{ marginBottom: '2.5rem' }}>
					<InputsSection>
						<InputBox
							type='password'
							label={t('screens.users.newPassword')}
							placeholder={t('screens.users.newPasswordPh')}
							value={resetPassword.value}
							onChange={(event) => {
								setResetPassword({ value: event.target.value, error: '' });
							}}
							errorMessage={resetPassword.error}
						/>
						<InputBox
							type='password'
							label={t('screens.users.confirmPassword')}
							placeholder={t('screens.users.confirmPasswordPh')}
							value={resetPasswordConfirm.value}
							onChange={(event) => {
								setResetPasswordConfirm({ value: event.target.value, error: '' });
							}}
							errorMessage={resetPasswordConfirm.error}
						/>
					</InputsSection>
					<ModalButtons
						submitButtonLabel={t('screens.users.resetPasswordBtn')}
						onSubmit={handleResetPassword}
						cancelButtonLabel={t('screens.users.cancel')}
						onCancel={handleResetPasswordModalClose}
					/>
				</ModalForm>
			)}
		</Modal>
	);
};

export default ResetPasswordModal;
